var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeroGraphicPlayButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 83,
    viewBox: "0 0 84 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80.248 41.5C80.248 20.59 63.115 3.625 41.998 3.625C20.881 3.625 3.74799 20.59 3.74799 41.5C3.74799 62.41 20.881 79.375 41.998 79.375C63.115 79.375 80.248 62.41 80.248 41.5Z",
    stroke: "white",
    strokeWidth: 6.125,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.096 56.974L56.897 43.335C57.214 43.143 57.477 42.874 57.659 42.553C57.842 42.231 57.937 41.869 57.937 41.5C57.937 41.132 57.842 40.77 57.659 40.448C57.477 40.127 57.214 39.858 56.897 39.666L34.096 26.027C33.769 25.833 33.396 25.729 33.015 25.725C32.634 25.721 32.259 25.817 31.928 26.004C31.597 26.191 31.322 26.462 31.132 26.788C30.942 27.115 30.843 27.486 30.845 27.863V55.137C30.843 55.515 30.942 55.886 31.132 56.212C31.322 56.539 31.597 56.81 31.928 56.997C32.259 57.184 32.634 57.28 33.015 57.276C33.396 57.272 33.769 57.168 34.096 56.974Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroGraphicPlayButton);
export default __webpack_public_path__ + "static/media/HeroGraphicPlayButton.9599e86d.svg";
export { ForwardRef as ReactComponent };